const getUtils = () => import(
  /* webpackChunkName: "searchadvanced" */
  './common'
)

export default getUtils;